// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"style__modalContent__NSHIc","demographicsRow":"style__demographicsRow__6R1z9"};